import axios, { AxiosResponse } from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

const resourceURL = `${API_URL}/stadsdelen`;

export interface Stadsdeel {
  id: number;
  naam: string;
}

export function mapNamen(stadsdelen: Stadsdeel[]): string[] {
  return stadsdelen.map((stadsdeel) => stadsdeel.naam);
}

export default {
  listStadsdelen(): Promise<AxiosResponse<Stadsdeel[]>> {
    return axios({
      method: 'get',
      url: resourceURL,
    });
  },
};
